import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { CustomLoggerService } from "./app/service/logger.service";
import { SlackService } from "./app/service/slack.service";
import { RefService } from "./app/service/ref.service";

if (environment.production) {
  enableProdMode();
}

const slackService = new SlackService();
const refService = new RefService();

const logger = new CustomLoggerService(slackService, refService);

// Override console methods
const dateString = new Date().toISOString();
// console.log = (msg: string, ...args: any[]) => logger.log(dateString, msg, ...args);
// console.error = (msg: string, ...args: any[]) => logger.error(dateString, msg, ...args);
// console.warn = (msg: string, ...args: any[]) => logger.warn(dateString, msg, ...args);


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
